import {
  Button,
  Container,
  Grid,
  Link,
  TextField,
  Typography,
} from '@mui/material';
import type { ReactElement } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ConversionDialog from 'components/Modals/ConversionDialog/ConversionDialog';
import FunctionalDialog from 'components/Modals/FunctionalDialog';
import { AppErrorManager } from 'errorHelper';
import UpsellModal from 'components/Modals/UpsellModal';
import { AnalyticsEventLocation } from 'services/analytics/entities';
import { UploadAudioModal } from 'components/Modals/UploadAudioModal';
import LabelsDemoSection from './LabelsDemoSection';
import ButtonsDemoSection from './ButtonsDemoSection';

export default function Demo(): ReactElement {
  const { t } = useTranslation();
  const [isConversionDialogOpen, setIsConversionDialogOpen] = useState(false);
  const [isFunctionalDialogOpen, setIsFunctionalDialogOpen] = useState(false);
  const [isUpsellModalOpen, setIsUpsellModalOpen] = useState(false);
  const [isUploadAudioModalOpen, setIsUploadAudioModalOpen] = useState(false);

  function methodDoesNotExist(): void {
    throw new Error('Function not implemented.');
  }

  return (
    <div>
      <Container sx={{ marginTop: 5 }}>
        <Typography variant="h1">{t('demo:typography:h1')}</Typography>
        <br />
        <Typography variant="h2">{t('demo:typography:h2')}</Typography>
        <br />
        <Typography variant="h3">{t('demo:typography:h3')}</Typography>
        <br />
        <Typography variant="h4">{t('demo:typography:h4')}</Typography>
        <br />
        <Typography variant="h5">{t('demo:typography:h5')}</Typography>
        <br />
        <Typography variant="h6">{t('demo:typography:h6')}</Typography>
        <br />
        <Typography variant="body1">
          {t('demo:typography:loremIpsum')}
        </Typography>
        <br />
        <Typography variant="body1">
          {t('demo:typography:loremIpsum')}
        </Typography>
        <br />
        <br />
        <br />
        {/* Text Field */}
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <TextField
              id="outlined-basic"
              label={t('demo:textFields:outlinedLabel')}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              id="outlined-basic-disabled"
              label={t('demo:textFields:outlinedLabel')}
              variant="outlined"
              disabled
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              id="outlined-basic-error"
              label={t('demo:textFields:outlinedLabel')}
              variant="outlined"
              error
              helperText={t('demo:textFields:errorText')}
            />
          </Grid>
        </Grid>
        <br />
        <br />
        <br />
        <h1>{t('demo:sub:title')}</h1>
        <h2>{t('general:siteTitle')}</h2>
        <h2>{t('demo:sub.key')}</h2>
        <h2>{t('demo:sub.key', { count: 1 })}</h2>
        <h2>{t('demo:sub.key', { count: 2 })}</h2>
        <br />
        <br />
        <br />
        <Link
          href="https://www.youtube.com/watch?v=JuYeHPFR3f0"
          variant="body1"
        >
          Pokemon Theme Song
        </Link>
        <br />
        <br />
        <br />
        <LabelsDemoSection />
        <br />
        <br />
        <br />
        <ButtonsDemoSection />
        <br />
        <br />
        <br />
        <Button onClick={() => setIsConversionDialogOpen(true)}>
          Open Conversion Dialog
        </Button>
        <Button onClick={() => setIsFunctionalDialogOpen(true)}>
          Open Functional Dialog
        </Button>
        <Button onClick={() => setIsUpsellModalOpen(true)}>
          Open Upsell Modal
        </Button>
        <Button onClick={() => setIsUploadAudioModalOpen(true)}>
          Open Updload Audio Modal
        </Button>
        <Button
          onClick={() => {
            try {
              methodDoesNotExist();
            } catch (error) {
              if (error instanceof Error) {
                AppErrorManager.sendError(error);
              }
            }
          }}
        >
          TEST SENTRY
        </Button>
        <br />
        <br />
        <br />
      </Container>

      <ConversionDialog
        title="Modal Title"
        state={{
          isOpen: isConversionDialogOpen,
          error: null,
          isLoading: false,
        }}
        action={{
          onSubmit: () => setIsConversionDialogOpen(false),
          onClose: () => setIsConversionDialogOpen(false),
          onExited: () => undefined,
        }}
        description="Modal description — Nullam neque nunc, fermentum eget iaculis ut,
        pellentesque vitae urna eget iaculis ut Proin non scelerisque lectus."
        submitText="Submit"
        closeText="Dismiss"
      />

      <FunctionalDialog
        title="Modal Title"
        state={{
          isOpen: isFunctionalDialogOpen,
          error: null,
          isLoading: false,
        }}
        action={{
          onSubmit: () => setIsFunctionalDialogOpen(false),
          onClose: () => setIsFunctionalDialogOpen(false),
          onExited: () => undefined,
        }}
        description="Modal description — Nullam neque nunc, fermentum eget iaculis ut,
        pellentesque vitae urna eget iaculis ut Proin non scelerisque lectus."
        submitText="Submit"
        closeText="Dismiss"
      />

      <UpsellModal
        isOpen={isUpsellModalOpen}
        onClose={() => setIsUpsellModalOpen(false)}
        location={AnalyticsEventLocation.MAIN_LIST}
      />

      <UploadAudioModal
        isOpen={isUploadAudioModalOpen}
        onClose={() => setIsUploadAudioModalOpen(false)}
      />
    </div>
  );
}
